/* eslint-disable vue/one-component-per-file */
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import VeeValidate from "vee-validate";
import vSelect from "vue-select";
import VModal from "vue-js-modal";
import DatePicker from "@/user/components/DatePicker.vue";

function formatDate(date) {
  return date ? date.toISOString().split("T")[0] : "";
}

export default function() {
  const { $ } = window;
  if ($("#reservations-page2").length < 1) {
    return;
  }

  Vue.use(VueLazyload);
  Vue.use(VeeValidate);
  Vue.use(VModal, { dynamic: true, dialog: true, injectModalsContainer: true });
  Vue.component("v-select", vSelect);
  Vue.component("date-picker", DatePicker);

  const url = new URL(window.location.href);
  const params = url.searchParams;

  const startDate = params.get("start_date");
  const endDate = params.get("end_date");
  const startOfCreatedDate = params.get("start_of_created_date");
  const endOfCreatedDate = params.get("end_of_created_date");
  const dateOption = params.get("date_option");
  const outletName = params.get("restaurant_name_like");
  const bookingId = params.get("reservation_id_like");
  const bookingStatus = params.get("reservation_status");
  const commissionStatus = params.get("commission_status");

  const today = new Date();
  const formattedStartDate = formatDate(today);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const formattedEndDate = formatDate(endOfMonth);

  const app = new Vue({
    el: "#reservations-page2",
    data: {
      bookingId: bookingId || "",
      bookingStatus: bookingStatus || "",
      commissionStatus: commissionStatus || "",
      outletName: outletName || "",
      startDate: startDate || startOfCreatedDate || "",
      endDate: endDate || endOfCreatedDate || "",
      dateOption: dateOption || "created_date",
      formDownload: {
        date_filter_type: "range",
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        date_type: "date",
        type: "excel",
        emails: "",
      },
      emailOptions: [],
    },
    methods: {
      setOrDeleteParam(paramName, value) {
        if (value) {
          params.set(paramName, value);
        } else {
          params.delete(paramName);
        }
      },
      async search(scope) {
        const isFormValid = await this.$validator.validateAll(scope);
        if (!isFormValid) {
          alert("Please input valid data");
          return;
        }

        this.setOrDeleteParam("restaurant_name_like", this.outletName);
        this.setOrDeleteParam("reservation_id_like", this.bookingId);
        this.setOrDeleteParam("reservation_status", this.bookingStatus);
        this.setOrDeleteParam("commission_status", this.commissionStatus);
        this.setOrDeleteParam("date_option", this.dateOption);

        if (this.dateOption === "dining_date") {
          this.setOrDeleteParam("start_date", this.startDate);
          this.setOrDeleteParam("end_date", this.endDate);
          params.delete("start_of_created_date");
          params.delete("end_of_created_date");
        }

        if (this.dateOption === "created_date") {
          this.setOrDeleteParam("start_of_created_date", this.startDate);
          this.setOrDeleteParam("end_of_created_date", this.endDate);
          params.delete("start_date");
          params.delete("end_date");
        }
        
        params.delete("page");

        url.search = params.toString();
        window.location.href = url.toString();
      },
      clearForm() {
        this.outletName = "";
        this.bookingId = "";
        this.bookingStatus = "";
        this.commissionStatus = "";
        this.startDate = "";
        this.endDate = "";
        this.dateOption = "created_date";
        this.search();
      },
      createOption(newOption) {
        this.$emit("option:created", newOption);
        return newOption;
      },
      async downloadReport() {
        const payload = {
          ...this.formDownload,
        };
        $.get({
          url: "/p/reservations/download.json",
          data: { ...payload },
          success: (response) => {
            alert(response.message || "Success");
            $("#close-download-reservations").click();
          },
          error: function(error) {
            const message =
              error.message ||
              error?.responseJSON?.errors[0] ||
              "Something went wrong";
            alert(message);
          },
        });
      },
    },
  });

  return app;
}

// Function to synchronize horizontal scroll between table header and table body
function syncHorizontalScroll(event) {
  const target = event.target;
  const table = document.querySelector(".table-blogger");
  const tableHeader = table.querySelector("thead");
  const tableBody = table.querySelector("tbody");

  if (target === tableHeader) {
    tableBody.scrollLeft = target.scrollLeft;
  } else if (target === tableBody) {
    tableHeader.scrollLeft = target.scrollLeft;
  }
}

// Adding event listeners for scroll events on table header and table body
const table = document.querySelector(".table-blogger");
if (table) {
  const tableHeader = table.querySelector("thead");
  const tableBody = table.querySelector("tbody");

  tableHeader.addEventListener("scroll", syncHorizontalScroll);
  tableBody.addEventListener("scroll", syncHorizontalScroll);
}
